import { withFieldConfigLayoutTabs } from "../components/withFieldConfigLayoutTabs.js";
import "react";
import { Checkbox, FormLayout, Radio, Text } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/DateTime/Config.tsx
var DateTimeFieldConfig = withFieldConfigLayoutTabs(({ config, layoutType, setMultipleOptionsKeys, setOptions, setOptionsKey }) => {
	if (layoutType === "Display") return /* @__PURE__ */ jsx(FormLayout, {
		space: "sm",
		children: /* @__PURE__ */ jsx(Text, {
			onChangeValue: (value) => setOptionsKey("displayLabel", value),
			label: "Label",
			value: config.options.displayLabel
		})
	});
	return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(FormLayout, {
		space: "sm",
		children: [
			/* @__PURE__ */ jsx(Text, {
				onChangeValue: (value) => {
					if (config.options.displayLabel === config.options.formLabel) setMultipleOptionsKeys([["formLabel", value], ["displayLabel", value]]);
					else setOptionsKey("formLabel", value);
				},
				value: config.options.formLabel
			}),
			/* @__PURE__ */ jsx(Text, {
				onChangeValue: (value) => setOptionsKey("subText", value),
				label: "Sub Text",
				value: config.options.subText
			}),
			/* @__PURE__ */ jsx(Radio, {
				label: "Mode",
				onChangeValue: (val) => setOptionsKey("mode", val),
				options: [
					{
						label: "Date",
						value: "date"
					},
					{
						label: "Time",
						value: "time"
					},
					{
						label: "Date & Time",
						value: "datetime"
					}
				],
				value: config.options.mode
			}),
			/* @__PURE__ */ jsx(Checkbox, {
				active: !!config.options.disabledStaticValue,
				label: "Fixed timestamp",
				onChangeValue: (active) => setOptionsKey("disabledStaticValue", active),
				subText: "Make this date/time a fixed timestamp that is not editable by the user"
			}),
			/* @__PURE__ */ jsx(Checkbox, {
				active: !!config.options.noDefaultValue,
				label: "No initial timestamp",
				onChangeValue: (active) => setOptionsKey("noDefaultValue", active),
				subText: "Do not automatically set the timestamp"
			}),
			/* @__PURE__ */ jsx(Checkbox, {
				active: !!config.options.required,
				label: "Required",
				onChangeValue: (active) => setOptionsKey("required", active),
				subText: "Make this a required field"
			})
		]
	}) });
});
//#endregion
export { DateTimeFieldConfig };

//# sourceMappingURL=Config.js.map